import React, { useEffect, useCallback, Component, useState } from 'react';
import styled from '@emotion/styled';
import CreatableSelect from 'react-select/creatable';
import { useField, Field } from 'formik';

const components = {
  DropdownIndicator: null
};

const createOption = label => ({
  label,
  value: label
});

/*
const MultiInputField = (props) => {
  const { name, label } = props;

  const [inputValue, setInputValue] = useState("");
  const [field, meta, helpers] = useField(props.name);
  const createOption = (label) => ({
    label,
    value: label,
  });
  
  const { value } = meta;
  const { setValue } = helpers;
  const [innerValue, setInnerValue] = useState( [] );

  
  useEffect(() => {
    const initalValue = ( value && value.split(",").map((v) => createOption(v)) ) || []
    setInnerValue(initalValue)
  }, [value]);

  useEffect(() => {
    setValue(innerValue.map((v) => v.label).join(","))
  },[innerValue])

  const handleInputChange = (inputValue) => setInputValue(inputValue);

  const handleKeyDown = (event) => {
    if (!inputValue) return;

    switch (event.key) {
      case "Enter":
      case "Tab":
      case ",":
        // don't add the same value twice
        if (value.split(',').indexOf(inputValue) > -1) {
          break;
        }

        setInnerValue((prev) => [...prev, createOption(inputValue)]);
        setInputValue("");

        // I must set the value here

        event.preventDefault();
        break;

      default:
        break;
    }
  };

  const handleChange = (value) => {
    if (value === null) {
      setInnerValue([]);
      setValue("");
      return;
    }

    // I must set the value here

    setInnerValue(value);
  };

  return (
    <div className='form-group row'>
      <label className='col-lg-3 col-form-label' htmlFor={name}>
        {label} :
      </label>
      <FieldContainer className='col-lg-9'>
        <CreatableSelect
          components={components}
          isClearable
          menuIsOpen={false}
          isMulti
          onInputChange={handleInputChange}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={""}
          inputValue={inputValue}
          value={innerValue}
        />
      </FieldContainer>
    </div>
  );
};
*/

class MultiInputField extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    inputValue: '',
    innerValue: []
  };

  render() {
    return (
      <Field name={this.props.name}>
        {({ form, field }) => (
          <div className='form-group '>
            <label className='' htmlFor={this.props.name}>
              {this.props.label} :
            </label>

            {/* <FieldContainer className='col-lg-9'> */}
            <CreatableSelect
              isDisabled={this.props.disabled}
              components={components}
              isClearable
              menuIsOpen={false}
              isMulti
              onInputChange={inputValue => {
                this.setState({
                  inputValue
                });
              }}
              onChange={value => {
                // after the change - if there is nothing left, set the true value & input value to empty
                if (value === null) {
                  form.setFieldValue(this.props.name, '');
                  this.setState({
                    innerValue: ''
                  });
                  return;
                }

                // after the change - set the local value to updated value (React Select State)
                this.setState(
                  {
                    innerValue: value
                  },
                  () => {
                    // make the true value a string , and split it with ","
                    form.setFieldValue(
                      this.props.name,
                      this.state.innerValue.map(v => v.label).join(',')
                    );
                  }
                );
              }}
              onBlur={event => {
                const { inputValue } = this.state;
                if (!inputValue) return;
                this.setState(
                  state => ({
                    inputValue: '',
                    innerValue: [...state.innerValue, createOption(inputValue)]
                  }),
                  () => {
                    // make the true value a string , and split it with ","
                    form.setFieldValue(
                      field.name,
                      this.state.innerValue.map(v => v.label).join(',')
                    );
                  }
                );

                event.preventDefault();
              }}
              onKeyDown={event => {
                const { inputValue } = this.state;
                if (!inputValue) return;

                switch (event.key) {
                  case 'Enter':
                  case 'Tab':
                  // case event.keyCode ===32 :
                  case ',':
                    console.log(field.value, 'field.value');
                    // if the item is already exits , don't add it
                    if (field.value.split(',').indexOf(inputValue) > -1) {
                      break;
                    }
                    // 1 - set the input value to empty string
                    // 2 - and then , create new option from it
                    this.setState(
                      state => ({
                        inputValue: '',
                        innerValue: [
                          ...state.innerValue,
                          createOption(inputValue)
                        ]
                      }),
                      () => {
                        // make the true value a string , and split it with ","
                        form.setFieldValue(
                          field.name,
                          this.state.innerValue.map(v => v.label).join(',')
                        );
                      }
                    );

                    event.preventDefault();
                    break;
                  default:
                    break;
                }
              }}
              placeholder={''}
              inputValue={this.state.inputValue}
              value={
                // convert the true value from string to array of objects
                // so React-Select can be able to understand it
                field.value && field.value.split(',').map(v => createOption(v))
              }
              name={field.name}
              /* {...field} */
            />
            {/* </FieldContainer> */}
          </div>
        )}
      </Field>
    );
  }
}

export default MultiInputField;

const FieldContainer = styled.div`
  position: relative;
  padding-bottom: '15px';
`;
